var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.clientprofile.avatar_image_url)?_c('v-avatar',{attrs:{"size":_vm.size}},[_c('img',{attrs:{"src":_vm.user.clientprofile.avatar_image_url + '?' + Math.random()}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserAvatarImage.vue?vue&type=template&id=3b4950ec&
// module id = 2696
// module chunks = 5